<!-- 下拉复选 -->
<template>
  <div class="multiple-choice">
    <el-select
      slot="reference"
      clearable
      v-model="selectData"
      placeholder="请选择"
      multiple
      popper-class="xm-new-multiple-choice"
      class="xm-new-multiple-choice-box"
      @remove-tag="handlerRemoveTag"
      @clear="reData"
    >
      <div class="option-model">
        <el-option style="display: none" value=""></el-option>

        <el-checkbox
          v-model="checkAll"
          @change="changeAllSelect"
          class="checkbox-style"
          :class="checkAll ? 'check-all-selected-style' : ''"
          v-if="isShowCheckAll"
        >
          <div>全部</div>
        </el-checkbox>
        <el-checkbox-group v-model="selectData">
          <div v-for="(item, index) in searchOption" :key="index">
            <el-option
              :label="item[optionLabelKey]"
              :value="item[optionValKey]"
            >
              <el-checkbox
                :label="item[optionValKey]"
                @change="checkOption(item)"
                class="checkbox-style"
              >
                {{ item[optionLabelKey] }}
              </el-checkbox>
            </el-option>
          </div>
        </el-checkbox-group>
      </div>
    </el-select>
    <div class="tags" v-show="selectData.length !== 0 && selectShow">
      <div class="arrow"></div>
      <div class="tags-item" v-for="(item, index) in selectData" :key="index">
        <span>{{ getLabel(item) }}</span>
        <span
          ><i
            class="el-tag__close el-icon-close"
            @click="deselect(index, item)"
          ></i
        ></span>
      </div>
    </div>
    <!-- 选其他选项出现的东西 -->
    <div class="other-data-box" v-if="isShowOtherInput">
      <div
        class="input-options-box"
        v-for="(item, index) in otherData"
        :key="index"
      >
        <el-input
          v-model="item[optionLabelKey]"
          @blur="multipleChange"
        ></el-input>
        <i
          class="iconfont add-icon"
          v-if="otherData?.length < maxOtherData"
          @click="handlerAddOtherData"
          >&#xe685;</i
        >
        <i
          class="iconfont del-icon"
          v-if="otherData?.length > 1"
          @click="handlerDelOtherData(index)"
          >&#xe683;</i
        >
      </div>
    </div>
  </div>
</template>

<script>
// 示例：src\pages\goods\brand\brandAdd.vue
export default {
  data() {
    return {
      selectData: [], //被选中的列表数据
      otherData: [],
      selectShow: true,
      checkAll: false, //控制全选
    };
  },
  props: {
    // 可以选的下拉列表
    // name 和 id  可以变，由optionLabelKey 和 optionValKey 控制
    optionsData: {
      type: Array,
      default: () => [
        // { name: '测试1', id: '1' },
        // { name: '测试2', id: '2' },
        // { name: '测试3', id: '3' },
        // { name: '测试4', id: '4' },
        // { name: '测试5', id: '5' },
        // { name: '测试6', id: '6' },
      ],
    },
    // 采用哪个字段为label值
    // 默认为 name
    optionLabelKey: {
      type: String,
      default: 'name',
    },
    // 采用哪个字段为value值
    // 默认为 id
    optionValKey: {
      type: String,
      default: 'id',
    },

    tagWidth: {
      type: String,
      default: '178px',
    },
    /**
     * 是否需要全选操作
     */
    isShowCheckAll: {
      type: Boolean,
      default: true,
    },
    /**
     * 如果选中当中某个数据，则取消其它选项，只保留当前选中的
     */
    onlySelectedData: {
      type: [String, Number],
      default: '',
    },
    /**
     * 用于选中其它的标识
     */
    otherSign: {
      type: [String, Number],
      default: '-1',
    },
    /**
     * 其它可加的最大数量
     */
    maxOtherData: {
      type: Number,
      default: 10,
    },
    // 回显
    needInitDisplayData: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    // 获取自定义下拉选项
    searchOption() {
      return this.optionsData || [];
    },
    isShowOtherInput() {
      let curSet = new Set(this.selectData);
      return curSet.has(this.otherSign) || false;
    },
  },
  watch: {
    needInitDisplayData: {
      handler(newVal) {
        this.initDataDisplay(newVal);
      },
      deep: true,
    },
  },
  methods: {
    // 数据处理
    selectOtherData(otherKey) {
      if (!this.otherSign) return;
      let setOptions = new Set(this.selectData);
      if (this.otherSign == otherKey) {
        console.log(!setOptions?.has(this.otherSign));
        if (!setOptions?.has(this.otherSign)) {
          const options = {};
          options[this.optionLabelKey] = '';
          this.otherData = [options];
        } else {
          this.otherData = [];
        }
      }
    },

    hasOtherValue() {
      let arr = this.otherData?.filter(item =>
        item?.[this.optionLabelKey]?.trim()
      );
      return arr || [];
    },

    // 数据回显
    initDataDisplay(data) {
      if (!data) return;
      const newDataIds =
        data?.filter(item => item?.id)?.map(item => item?.id) || [];
      const mainPlatform = new Set(newDataIds);
      const otherPlatform =
        data?.find(item => item?.name == '其他' || item?.is_custom == '1')
          ?.content || [];

      this.selectData = [...mainPlatform];

      this.otherData = otherPlatform?.map(item => {
        const options = {};
        options[this.optionLabelKey] = item;
        return options;
      });

      if (this.otherData?.length == 0) {
        if (mainPlatform?.has(this.otherSign)) {
          const options = {};
          options[this.optionLabelKey] = '';
          this.otherData = [options];
        }
      }
    },
    // 用户行为
    // 点击全选
    changeAllSelect(checkbox, $event) {
      this.checkAll = checkbox;
      let setOptions = new Set();
      if (this.checkAll) {
        // 全选
        for (let i = 0; i < this.optionsData.length; i++) {
          const curObj = this.optionsData[i];
          if (!setOptions?.has(curObj?.[this.optionValKey])) {
            setOptions.add(curObj?.[this.optionValKey], curObj);
          }
        }
        this.selectOtherData(this.otherSign);
        this.selectData = [...setOptions];
      } else {
        // 取消全选
        this.selectData = [];
        this.otherData = [];
      }
      this.multipleChange();

      $event?.stopPropagation();
    },

    multipleChange() {
      if (this.selectData?.length === this.optionsData?.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
      this.$emit('multiple-change', this.getObj(), this.hasOtherValue());
    },
    // 点击下拉选项中复选框
    checkOption(checkInfo) {
      const curValKey = checkInfo?.[this.optionValKey];
      let curSet = new Set(this.selectData);

      if (!curSet?.has(curValKey)) {
        if (this.onlySelectedData === curValKey) {
          this.otherData = [];
          curSet.clear();
        } else {
          curSet.delete(this.onlySelectedData);
        }
        curSet.add(curValKey);
      } else {
        curSet.delete(curValKey);
      }
      this.selectOtherData(curValKey);
      this.selectData = [...curSet];
      this.multipleChange();
    },
    //获取完整的被选中列表对象
    getObj() {
      let arr = this.optionsData.reduce((box, item) => {
        // 筛选出被选中的 optionValKey ，加入box中
        if (this.selectData.some(value => value == item[this.optionValKey])) {
          box?.push(item);
        }

        return box;
      }, []);
      return arr || [];
    },
    // 悬浮弹框的
    //根据 optionValKey 值获取对应 optionLabelKey 值
    getLabel(value) {
      let infoVal =
        this.optionsData?.filter(
          item => item[this.optionValKey] === value
        )?.[0] || {};
      if (infoVal?.[this.optionLabelKey]) {
        return infoVal?.[this.optionLabelKey];
      }
      return '';
    },
    // 悬浮弹框点击删除图标
    deselect(index, key) {
      this.selectOtherData(key);
      this.selectData.splice(index, 1);
      this.multipleChange();
    },
    // 数据重置
    reData() {
      this.selectData = [];
      this.otherData = [];
      this.$emit('re-data', this.getObj(), this.hasOtherValue());
    },

    handlerAddOtherData() {
      this.otherData.push({ value: '' });
    },

    handlerDelOtherData(index) {
      this.otherData.splice(index, 1);
      this.multipleChange();
    },

    handlerRemoveTag(key) {
      if (this.otherSign == key) {
        this.otherData = [];
      }
      this.multipleChange();
    },
  },
  mounted() {
    this.initDataDisplay(this.needInitDisplayData);
  },
};
</script>

<style lang="scss" scoped>
.multiple-choice {
  width: v-bind(tagWidth);

  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  ::v-deep .el-input__inner {
    width: v-bind(tagWidth);
  }

  .other-data-box {
    .input-options-box {
      display: flex;
      margin: 10px 0;
      &:last-child {
        margin-bottom: 0;
      }
      .iconfont {
        font-size: 20px;
        cursor: pointer;
      }
      .add-icon {
        color: var(--xm-color);
        margin: 0 10px;
      }
      .del-icon {
        color: red;
      }
    }
  }
}
.xm-new-multiple-choice-box {
  &:hover {
    + .tags {
      visibility: visible;
      opacity: 1;
    }
  }
}

.tabs-box {
  width: fit-content;
  // margin-top: 10px;
  background: #ffffff;
  height: 40px;
  padding: 8px 10px;
}
.tags {
  font-size: 12px;
  font-weight: 400;
  width: fit-content;
  margin-top: 10px;
  background: #ffffff;
  padding: 8px 10px 0 10px;
  visibility: hidden;
  opacity: 0;
  transition: 0.25s ease-in;
  position: absolute;
  z-index: 1000;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

  .arrow {
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-bottom: 6px solid #ffffff;
    // background: black;
    position: absolute;
    top: -12px;
    left: 16px;
  }

  .tags-item {
    display: inline-block;
    padding: 2px 10px 0 10px;
    background: #f4f4f5;
    margin-right: 10px;
    margin-bottom: 10px;
    color: #909399;
    i {
      text-align: center;
      position: relative;
      cursor: pointer;
      font-size: 12px;
      vertical-align: middle;
      top: -1px;
      right: -5px;
    }

    &:last-of-type {
      margin-right: 0px;
    }
  }
  &:hover {
    visibility: visible;
    opacity: 1;
  }
}
.multiple-choice ::v-deep .el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
}
</style>
<style lang="scss">
// 特殊的样式
.xm-new-multiple-choice {
  // 图标样式
  .el-input__prefix {
    line-height: 40px;
    margin-top: 4px;
  }

  // 下拉选项内容
  .el-select-dropdown__item {
    text-align: left !important;
    padding: 0 !important;
  }
  .checkbox-style {
    // padding: 10px 20px;
    width: -webkit-fill-available;
    cursor: pointer;
    padding: 0 40px 0 20px;
    line-height: 34px;
    &:hover {
      background-color: #fff2e6 !important;
    }
  }
  .check-all-selected-style {
    background-color: #fff2e6 !important;
  }
}
</style>
